import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconOctagon = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--octagon")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M8.27421356,3 L3,8.27421356 L3,15.7257864 L8.27421356,21 L15.7257864,21 L21,15.7257864 L21,8.27421356 L15.7257864,3 L8.27421356,3 Z M7.86,1 L16.14,1 C16.4052165,1 16.6595704,1.10535684 16.8471068,1.29289322 L22.7071068,7.15289322 C22.8946432,7.3404296 23,7.59478351 23,7.86 L23,16.14 C23,16.4052165 22.8946432,16.6595704 22.7071068,16.8471068 L16.8471068,22.7071068 C16.6595704,22.8946432 16.4052165,23 16.14,23 L7.86,23 C7.59478351,23 7.3404296,22.8946432 7.15289322,22.7071068 L1.29289322,16.8471068 C1.10535684,16.6595704 1,16.4052165 1,16.14 L1,7.86 C1,7.59478351 1.10535684,7.3404296 1.29289322,7.15289322 L7.15289322,1.29289322 C7.3404296,1.10535684 7.59478351,1 7.86,1 Z" id="icon--centivo--octagon"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1466.000000, -860.000000)"/>
          <g id="Icon/octagon">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--octagon"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--octagon"/>
          </g>
      </g>
  </IconWrapper>
)
